import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useAsyncDispatch } from '../../../redux/store';

export interface UseApplicationLayout {
  menuColapsed: boolean;
  setMenuColapsed: Dispatch<SetStateAction<boolean>>;
}

const useApplicationLayout = (): UseApplicationLayout => {
  const [menuColapsed, setMenuColapsed] = useState<boolean>(true);
  const dispatch = useAsyncDispatch();
  // const user = useSelector(selectUsuario);

  useEffect(() => {
    const tokenValidate = (): void => {
      // if (
      //   user === undefined ||
      //   user.accessToken.token === undefined ||
      //   !JWTValidate(user.accessToken.token)
      // ) {
      //   dispatch(logOut());
      // }
    };

    tokenValidate();
  }, []);

  return {
    menuColapsed,
    setMenuColapsed,
  };
};

export default useApplicationLayout;
